import { createSlice } from "@reduxjs/toolkit";

export const DeviceArraySlice = createSlice({
    name:"DeviceArraySlice",
    initialState:{
        device_array:[]
    },
    reducers:{
        ADD_DEVICE_ARRAY:(state, action)=>{
            if(action.payload!==null){
                state.device_array=action.payload
            }
        }
    },

})

export const {
    ADD_DEVICE_ARRAY
} = DeviceArraySlice.actions

export default DeviceArraySlice.reducer